// Ported from design/project/App16-Settling.dc.html, then wired: shows the last price until the result event arrives.
import { battleState } from "../battleView.js";
import { fmtPrice } from "../format.js";
import { useGame } from "../game.js";
import { fit } from "../fit.js";

export function App16_Settling() {
  const { battle, prices } = useGame();
  if (!battle || battle.startPrice === null) return null;
  const st = battleState(battle, prices[battle.arena], "long");
  const final = battle.endPrice !== null ? Number(battle.endPrice) : st.last;
  const diff = final - st.start;
  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "90px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad" style={{ height: "100%", paddingBottom: fit(20, 44) }}>
    <div className="top">
      <span className="chip chipN">TIME'S UP</span>
    </div>

    <div style={{ marginTop: fit(8, 40), position: "relative", height: fit(160, 230), display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg width="230" height="230" viewBox="0 0 230 230" style={{ height: fit(160, 230), width: "auto", position: "absolute", animation: "ddSpin 2.4s linear infinite" }} aria-hidden="true">
        <defs><linearGradient id="stArc" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#CCFF00"></stop><stop offset="1" stopColor="#CCFF00" stopOpacity="0"></stop></linearGradient></defs>
        <circle cx="115" cy="115" r="104" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="6"></circle>
        <circle cx="115" cy="115" r="104" fill="none" stroke="url(#stArc)" strokeWidth="6" strokeLinecap="round" strokeDasharray="300 354"></circle>
      </svg>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
        <span className="lbl">FINAL PRICE</span>
        <span className="mono" style={{ fontWeight: "800", fontSize: "30px" }}>{fmtPrice(battle.arena, final)}</span>
        <span className={`mono ${diff >= 0 ? "lime" : "red"}`} style={{ fontSize: "13px", fontWeight: "700" }}>{diff >= 0 ? "+" : "-"}{fmtPrice(battle.arena, Math.abs(diff))} vs entry</span>
      </div>
    </div>

    <h1 className="h1" style={{ marginTop: fit(12, 26), textAlign: "center" }}>Reading the oracle</h1>
    <p className="muted" style={{ margin: "8px 0 0", textAlign: "center", fontSize: "14px" }}>The price sources must agree before anyone gets paid.</p>

    <div className="g" style={{ marginTop: fit(12, 22), borderRadius: "20px", padding: "6px 0" }}>
      <div className="li">
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#CCFF00"></circle><path d="M7 12.5 L10.5 16 L17 9" stroke="#0B0E14" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg>
        <span style={{ flex: "1", fontSize: "14px" }}>Final price captured</span><span className="mono muted" style={{ fontSize: "12px" }}>00:00.000</span>
      </div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li">
        <svg width="22" height="22" viewBox="0 0 24 24" style={{ animation: "ddSpin 1s linear infinite" }} aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="#30363D" strokeWidth="3"></circle><path d="M12 3 A9 9 0 0 1 21 12" fill="none" stroke="#CCFF00" strokeWidth="3" strokeLinecap="round"></path></svg>
        <span style={{ flex: "1", fontSize: "14px" }}>Oracle consensus</span><span className="mono lime" style={{ fontSize: "12px" }}>AGREED</span>
      </div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li" style={{ opacity: "0.5" }}>
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="#30363D" strokeWidth="3"></circle></svg>
        <span style={{ flex: "1", fontSize: "14px" }}>Credit payout to battle balance</span><span className="mono muted" style={{ fontSize: "12px" }}>NEXT</span>
      </div>
    </div>

    <p className="muted" style={{ margin: "auto 0 0", textAlign: "center", fontSize: "12px" }}>Usually under 5 seconds. If the oracle stalls, both stakes are refunded in full.</p>
  </div>
</div>
    </>
  );
}
